import styled from "styled-components";
import { PageName } from "styles/typography";
import { responsive } from "theme/reponsive";

export const InputWrapper = styled.div`
   margin: 20px 0;
   ${responsive("$medium")`
   display: grid;
   grid-template-columns: repeat(1, 1fr);
   row-gap: 20px;
   width: 300px;
`}
   &.mt-13 {
      margin: 13px 0 0;
      &:first-of-type {
         margin: 0;
      }
   }
   &.mt-15 {
      margin: 15px 0 0;
      &:first-of-type {
         margin: 0;
      }
   }
   &.grid-2-2 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;
      @media screen and (max-width: 768px) {
         display: grid;
         grid-template-columns: repeat(1, 1fr);
         row-gap: 20px;
         width: 100%;
      }
   }
`;

export const FormWrapper = styled.div`
   padding: 10px 30px 30px 30px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
   margin: 10px auto 50px auto;
   width: 100%;
`;

export const ProductFormWrapper = styled.div`
   padding: 56px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
   margin: 10px auto 50px auto;
   width: 100%;
`;

export const PartnerFormWrapper = styled.div`
   padding: 10px 30px 30px 30px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
   margin: 10px auto 50px auto;
   width: 65%;
`;

export const BlogGridWrapper = styled.div`
   display: grid;
   grid-template-columns: 1.7fr 1.3fr;
   width: 100%;
   column-gap: 20px;
   /* padding: 10px 30px 30px 30px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
   max-width: 750px;
   margin: 30px auto 50px auto; */
`;

export const StudyGridWrapper = styled.div`
   display: grid;
   grid-template-columns: 2fr 1fr;
   width: 100%;
   column-gap: 20px;
   /* padding: 10px 30px 30px 30px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
   max-width: 750px;
   margin: 30px auto 50px auto; */
`;

export const CourseGridWrapper = styled.div`
   display: grid;
   grid-template-columns: 2.3fr 0.7fr;
   width: 100%;
   column-gap: 20px;
   /* padding: 10px 30px 30px 30px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
   max-width: 750px;
   margin: 30px auto 50px auto; */
`;

export const CenterWrapper = styled.div`
   display: flex;
   justify-content: center;
   width: 100%;
`;

export const PreviewWrapper = styled.div`
   max-width: 500px;
   min-width: 100%;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 2%);
   margin: 10px auto 50px auto;
   word-break: break-all;
   overflow-y: hidden;
   ${PageName} {
      background-color: #fcfcfc;
      margin: 0;
      padding: 10px 15px;
      font-weight: 400;
      border: 1px solid #e7e5e5;
      font-size: 17px;
   }
   .preview {
      min-height: 100%;
      overflow-y: auto;
      padding: 30px 13px 10px 13px;
   }
   img {
      max-width: 100%;
      height: auto;
   }
`;
export const FormFooter = styled.div`
   .page {
      color: #3578e5;
      font-weight: 400;
      font-size: 12px;
      margin-top: 23px;
   }
   .form-btn {
      margin-top: 22px;
   }
   .dual-btn {
      margin-top: 22px;
      display: flex;
      gap: 30px;
   }
`;

export const ScholarshipGridWrapper = styled.div`
   display: grid;
   grid-template-columns: 1.9fr 1.1fr;
   width: 100%;
   column-gap: 20px;
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 5px;
`;

export const LoanFormWrapper = styled.div`
   padding: 30px 80px 100px 80px;
   background-color: ${({ theme }) => theme.colors?.white};
   box-shadow: 0 3px 25px rgb(0 0 0 / 4%);
   border-radius: 10px;
   margin: 10px auto 50px auto;
   width: 100%;
   .header {
      text-align: center;
      margin-bottom: 30px;
      h1 {
         font-size: 24px;
         font-weight: 700;
      }
      p {
         font-size: 16px;
         font-weight: 400;
      }
   }
   .heading {
      font-size: 18px;
      font-weight: 600;
      margin-top: 20px;
      margin-bottom: 10px;
   }

   .btn-div {
      margin-top: 30px;
      display: flex;
      align-items: center;
      gap: 20px;
   }

   @media screen and (max-width: 768px) {
      padding: 10px;
   }
`;

export const LoanInputWrapper = styled.div`
   margin: 20px 0;
   ${responsive("$medium")`
   display: grid;
   grid-template-columns: repeat(1, 1fr);
   row-gap: 20px;
   width: 100%;
`}
   &.mt-13 {
      margin: 13px 0 0;
      &:first-of-type {
         margin: 0;
      }
   }
   &.mt-15 {
      margin: 15px 0 0;
      &:first-of-type {
         margin: 0;
      }
   }
   &.grid-2-2 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;
      @media screen and (max-width: 768px) {
         display: grid;
         grid-template-columns: repeat(1, 1fr);
         row-gap: 20px;
         width: 100%;
      }
   }
`;
